import {
  keepPreviousData,
  useQuery,
  type UseQueryResult,
} from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

/**
 * Total row count for a submitted query. Independent failure mode from the
 * results feed — count failures should not hide rows; consumers can ignore
 * `error` and treat `data === undefined` as "count not available."
 */
export function useQueryCount(
  queryId: string | undefined,
): UseQueryResult<number, Error> {
  const { queryService } = useDomainServices();

  return useQuery({
    queryKey: ["queryResultCount", queryId],
    queryFn: ({ signal }) =>
      queryService.getQueryResultCount(queryId!, { abortSignal: signal }),
    enabled: !!queryId,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
}
